import { Form, Input, InputNumber, Radio } from '@seiue/ui'
import TextArea from 'antd/es/input/TextArea'
import React from 'react'
import styled from 'styled-components'

import { CustomizeFormItemProps, FormItemType } from './types'

/**
 * Form.Item配置化
 * @param param - 参数
 * @param param.type - 组件类型
 * @param param.formItemConfig - FormItem属性
 * @param param.componentConfig - FormItem内部组件属性
 * @param param.hidden - 是否隐藏
 * @returns React.ReactNode
 */
export const FormItem: React.FC<CustomizeFormItemProps> = ({
  type,
  formItemConfig,
  componentConfig,
  hidden,
}) => {
  const getComponent = () => {
    const { radioGroupProps, inputProps, textAreaProps, inputNumberProps } =
      componentConfig || {}
    const component = {
      [FormItemType.Input]: <Input {...inputProps} />,
      [FormItemType.Number]: <InputNumber {...inputNumberProps} />,
      [FormItemType.TextArea]: <TextArea {...textAreaProps} />,
      [FormItemType.Radio]: <Radio.Group {...radioGroupProps} />,
    }
    return component[type] || null
  }

  if (hidden) {
    return null
  }
  return (
    <Wrapper>
      <Form.Item {...formItemConfig}>{getComponent()}</Form.Item>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  &&& {
    .ant-input-number-handler-wrap {
      display: none;
    }
    .ant-form-item-extra {
      font-size: 12px;
      color: ${(props) => props.theme.text._3};
    }
    .ant-form-item-explain-error {
      font-size: 12px;
    }
  }
`
